import { configureStore } from "@reduxjs/toolkit";
import storytellersReducer from "./storytellersSlice";

export const store = configureStore({
  reducer: {
    storytellers: storytellersReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST"],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
